import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { ButtonLabel } from '../shared';
import { getOutlineThemeConfig, OutlineButtonContainer } from '../styles';

/**
 * @deprecated This is deprecated in horizon. Please use secondary outlined button variant.
 */
var OutlineButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      isLoading = _ref.isLoading,
      loadingText = _ref.loadingText,
      dataTest = _ref['data-test'],
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      theme = _ref.theme,
      leadingIcon = _ref.leadingIcon,
      trailingIcon = _ref.trailingIcon,
      buttonProps = _objectWithoutProperties(_ref, ["children", "size", "isLoading", "loadingText", "data-test", "type", "theme", "leadingIcon", "trailingIcon"]);

  var componentTheme = useComponentTheme({
    name: 'OutlineButton',
    theme: getOutlineThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(OutlineButtonContainer, _extends({}, buttonProps, {
    "data-test": dataTest ? dataTest : undefined,
    size: size,
    isLoading: isLoading,
    ref: ref,
    type: type,
    customTheme: componentTheme
  }), /*#__PURE__*/React.createElement(ButtonLabel, {
    isLoading: isLoading,
    size: size,
    loadingText: loadingText,
    customTheme: componentTheme,
    leadingIcon: leadingIcon,
    trailingIcon: trailingIcon
  }, children));
});
OutlineButton.displayName = 'OutlineButton';
export default OutlineButton;